// extracted by mini-css-extract-plugin
export default {"dropdown":"SortDropdown_dropdown__aclmN","wrapper":"SortDropdown_wrapper__OKakI","group":"SortDropdown_group__z1zPA"};